import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import { Result } from 'antd';
import { TextService } from "../../Services/TextService";
import { useGoogleAnalyticsConversion } from "../../Hooks/useGoogleAnalyticsConversion";


const NewUserCreated = () => {
  const GetText = TextService.GetText;

  // Trigger Google Analytics conversion event when page loads
  useGoogleAnalyticsConversion('conversion_event_signup');
  return <div id="start">
    <Result
      status="success"
      title={GetText("NewUserCreated_Title")}
      subTitle={GetText("NewUserCreated_Description")}
    />
  </div>
};

export default NewUserCreated;